module.exports = __webpack_public_path__ + "static/media/Tony_Moly_logo.8932695f.png";